import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { boxInfo } from '../../../../modal/boxInfo';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { orgao } from '../../../../modal/regional/orgao';
import { OrgaoService } from '../../../../service/orgao.service';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ConfirmDialogComponent } from '../../dialog/confirmdialog.component';
import { LoadingIndicadoresService } from '../../../../loading-indicadores/loading-indicadores.service';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { parametroHeader } from '../../../../modal/parametroHeader';
import { ParametroHeaderService } from '../../../../service/parametroHeader.service';

@Component({
    selector: 'app-cadastro-adicionar-parametro-header',
    standalone: true,
    imports: [
        MatSidenavModule,
        MatCardModule,
        MatMenuModule,
        CommonModule,
        RouterLink,
        RouterOutlet,
        RouterModule,
        FormsModule,
        MatPaginatorModule,
        MatTooltipModule
    ],
    templateUrl: './cadastro-adicionar-parametro-header.component.html',
    styleUrl: './cadastro-adicionar-parametro-header.component.scss'
})

export class CadastroAdicionarParametroHeaderComponent implements OnInit {
    data = [];
    public listaOrg: parametroHeader[] = [];
    novoItem: parametroHeader = new parametroHeader();
    private originalCodigo: string | undefined;
    public novoCad = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private loadingService: LoadingIndicadoresService,
        private ParametroHeaderService: ParametroHeaderService) {
        try {
            let login = localStorage.getItem('login');
            if (login == null || login == undefined)
                this.router.navigate(['/iniciar']);
        }
        catch (ex) {
            this.router.navigate(['/iniciar']);
        }
    }

    numNull(value: any)
  {
    if(value == null || value == undefined || value == "")
      return false
    else return true;
  }

    submitForm() {
        this.loadingService.show();
            if(!this.numNull(this.novoItem.id) || !this.numNull(this.novoItem.tipo) ||
    !this.numNull(this.novoItem.foto)){
            this.loadingService.hidePosto();
            alert("Digite todos os campos obrigatorios!")
            return;
        }

        // << CONTROLE DE SEGURANÇA NO ANGULAR:
        //if (this.novoItem.id != null) {
        //    this.novoItem.id = this.originalCodigo;
        //}
        // FIM DO CONTROLE >>

        this.ParametroHeaderService.adicionarItem(this.novoItem, this.novoCad).subscribe({
            next: () => { // Lida com o sucesso
                this.loadingService.hidePosto();
                console.log('Novo item adicionado com sucesso', this.novoItem);
                this.novoItem = new parametroHeader();
                this.router.navigate(['parametro-header-listagem']);
            },
            error: (error) => { // Lida com o erro
                this.loadingService.hidePosto();
                console.error('Erro ao adicionar novo item:', error);
            }
        });
    }


    Limpar() {
        this.novoItem = new parametroHeader();
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let idEditar = params['IdEditar'];
            let idNovo = params['IdNovo'];
            if (idEditar != undefined){
                this.abrirEditarItem(idEditar);
                this.novoCad = false;
            }
            else
            {
                this.novoItem.id = idNovo;
            }
        });
    }

    abrirEditarItem(id: string | null): void {
        if (id != undefined) {
            this.ParametroHeaderService.editarItem(id?.toString()).subscribe(
                (response) => {

                    let element = response["Parametro_Header"];

                    this.novoItem = new parametroHeader(element['id'], element['sistema'], element['width'],
         element['height'], element['url_css'], element['foto'], element['alt'], element['css'], element['nome']
         , element['tipo'], element['periodoEleitoral'], element['ativo'])
                },
                (error) => {
                    console.error('Erro ao excluir o item:', error);
                }
            );
        }
    }

    onFileSelected(event: any) {

        const file: File = event.target.files[0];
      
        if (!file) {
          return;
        }
      
        const reader = new FileReader();
      
        reader.onload = () => {
      
          const base64 = reader.result as string;
      
          // remove "data:image/png;base64,"
          this.novoItem.foto = base64.split(',')[1];
    
        };
      
        reader.readAsDataURL(file);
      }
}
